import React from "react";
import {CheckboxContainer} from "./styles";

// eslint-disable-next-line react/prop-types
export default function Checkbox({type = "checkbox", name, checked = false, onChange, label = '', value = ''}) {
    return (
        <CheckboxContainer>
            <input type={type} name={name} defaultChecked={checked} onChange={onChange} value={value}
                   className={`${type === 'checkbox' && 'form-check-input'} mt-0`}/>
            {label &&
                <label className="form-check-label">
                    {label}
                </label>
            }
        </CheckboxContainer>
    )
}
